import { render, staticRenderFns } from "./afterSaleList.vue?vue&type=template&id=5c97349a&scoped=true&"
import script from "./afterSaleList.vue?vue&type=script&lang=js&"
export * from "./afterSaleList.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleList.vue?vue&type=style&index=0&id=5c97349a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c97349a",
  null
  
)

export default component.exports